<h2>{{ "CASE_FORM.FORMS.USER_EMAIL.TITLE" | translate }}</h2>

<form
  class="top-margin-15"
  data-testid="guest-user-form"
  [formGroup]="form"
>
  <payee-form-field
    width="max"
    height="tall"
  >
    <input
      payee-input
      formControlName="email"
      type="email"
      autocomplete="email"
      inputmode="email"
      data-testid="guest-email"
      [placeholder]="'CASE_FORM.FORMS.USER_EMAIL.EMAIL_PLACEHOLDER' | translate"
    />
    @if (userEmail.invalid && userEmail.dirty) {
      <ng-container payee-error>
        @if (userEmail.hasError("required")) {
          <span>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </span>
        }
        @if (userEmail.hasError("email")) {
          <span>
            {{ "ERROR_MESSAGES.INVALID_FORMAT" | translate }}
          </span>
        }
        @if (userEmail.hasError("unknown")) {
          <span>{{ userEmail.errors?.unknown }}</span>
        }
      </ng-container>
    }
  </payee-form-field>

  @if (!showLoginForm) {
    @if (!showLoginForm) {
      <div class="flex column top-margin-15">
        <mat-checkbox
          class="tos-checkbox"
          formControlName="terms_of_service"
          data-testid="guest-tos"
        >
          <div class="tos-label">
            <span>
              {{ "CASE_FORM.FORMS.USER_EMAIL.TOS_TEXT_PART_1" | translate }}
            </span>
            <a
              target="_blank"
              href="https://www.payee.tech/legal/terms-and-conditions"
            >
              {{ "CASE_FORM.FORMS.USER_EMAIL.TOS_LINK" | translate }}
            </a>
            <span>
              {{ "CASE_FORM.FORMS.USER_EMAIL.TOS_TEXT_PART_2" | translate }}
            </span>
            <a
              target="_blank"
              href="https://www.payee.tech/legal/privacy-policy"
            >
              {{ "CASE_FORM.FORMS.USER_EMAIL.PRIVACY_POLICY_LINK" | translate }}
            </a>
          </div>
        </mat-checkbox>
        @if (terms_of_service.invalid && terms_of_service.dirty) {
          <mat-error>
            {{ "CASE_FORM.FORMS.USER_EMAIL.ERRORS.TOS_REQUIRED" | translate }}
          </mat-error>
        }
      </div>
    }
    <div class="top-margin-20 login-prompt">
      {{ "CASE_FORM.FORMS.USER_EMAIL.HAVE_ACCOUNT_PROMPT" | translate }}
      <a
        href="#"
        class="login-link"
        (click)="onShowLoginForm(); $event.preventDefault()"
      >
        {{ "CASE_FORM.FORMS.USER_EMAIL.LOGIN_LINK_TEXT" | translate }}
      </a>
    </div>
  } @else {
    <payee-form-field
      width="max"
      height="tall"
    >
      <span payee-label>{{ "CASE_FORM.FORMS.USER_EMAIL.PASSWORD_LABEL" | translate }}</span>
      <input
        payee-input
        formControlName="password"
        type="password"
        autocomplete="current-password"
      />
      @if (password.touched && password.invalid) {
        <ng-container payee-error>
          @if (password.hasError("required")) {
            <span>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
          }
        </ng-container>
      }
    </payee-form-field>
    <div class="top-margin-20 login-prompt">
      {{ "CASE_FORM.FORMS.USER_EMAIL.NO_ACCOUNT_PROMPT" | translate }}
      <a
        href="#"
        class="login-link"
        (click)="onShowRegisterForm(); $event.preventDefault()"
      >
        {{ "CASE_FORM.FORMS.USER_EMAIL.REGISTER_LINK_TEXT" | translate }}
      </a>
    </div>
  }
</form>

<payee-info class="top-margin-15">
  {{ "CASE_FORM.FORMS.USER_EMAIL.INFO_TEXT" | translate }}
</payee-info>
